import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";

export type CountryWithRegionDto = {
  id: number;
  name: string;
  regionId: number | null;
};

export async function getCountriesWithRegions(
  divisionId: number
): Promise<CountryWithRegionDto[]> {
  const localApi = await getLocalApi();
  const path = (apiConfig as any).region_get_countries_by_division.replace(
    "{divisionId}",
    String(divisionId)
  );
  const list = await localApi.fetchList(
    path,
    (dto: any) => ({
      id: dto.id,
      name: dto.name ?? "",
      regionId: dto.regionId != null && dto.regionId !== 0 ? dto.regionId : null,
    }),
    "Unable to fetch countries"
  );
  return [...list].sort((a, b) => (a.name || "").localeCompare(b.name || ""));
}